import { useAuth0 } from '@auth0/auth0-react'
import { useMemo } from 'react'

import auth0Config from '../auth0/config/auth0'
import VariantLensAPIClient from '../VariantLensAPIClient'

export function useVariantLensApiClient() {
  const { getAccessTokenSilently } = useAuth0()

  return useMemo(() => {
    return VariantLensAPIClient.getInstance(async () =>
      getAccessTokenSilently({
        authorizationParams: {
          audience: auth0Config.authorizationParams?.audience,
        },
      })
    )
  }, [getAccessTokenSilently])
}
